import { createContext } from "react"
import { Consumer } from "@rails/actioncable"

export interface ICableContextState {
  apiToken: string | null
  consumer: Consumer | null
}

export const cableContextInitialState: ICableContextState = {
  apiToken: null,
  consumer: null
}

export const CableContext = createContext<ICableContextState>(cableContextInitialState)
